<template>
  <nav class="layout-footer footer bg-footer-theme">
    <v-register-newsletter
      v-if="showNewsLetterBar"
      :small="true"
    />
    <div
      class="container-fluid d-flex flex-wrap
       justify-content-between text-center container-p-x pb-3"
    >
      <div class="pt-3">
        <span class="footer-text mr-2">commercialreview</span>
        © &nbsp; | &nbsp;
        <a
          class="ml-2"
          target="_blank"
          href="https://www.facebook.com/commercialreview.nl/"
        >
          <i class="fab fa-facebook text-facebook"></i>
        </a>
        <a
          class="ml-2"
          target="_blank"
          href="https://twitter.com/commercialrvw/"
        >
          <i class="fab fa-x-twitter"></i>
        </a>
        <a
          class="ml-2"
          target="_blank"
          href="https://www.instagram.com/commercialreview.nl/"
        >
          <i class="fab fa-instagram text-instagram"></i>
        </a>
        <a
          class="ml-2"
          target="_blank"
          href="https://www.linkedin.com/company/commercialreview/"
        >
          <i class="fab fa-linkedin-in text-linkedin"></i>
        </a>
      </div>

      <div>
        <a
          href="https://commercialreview.nl/over-ons/"
          target="_blank"
          class="footer-link pt-3 ml-4"
        >
          {{ $t('phrase.about_us') }}
        </a>
        <a
          href="https://commercialreview.nl/privacystatement/"
          target="_blank"
          class="footer-link pt-3 ml-4"
        >
          {{ $t('word.privacy_statement') }}
        </a>
        <a
          href="https://commercialreview.nl/voorwaarden/"
          target="_blank"
          class="footer-link pt-3 ml-4"
        >
          {{ $t('word.terms') }}
        </a>
        <a
          href="https://commercialreview.nl/contact/"
          target="_blank"
          class="footer-link pt-3 ml-4"
        >
          {{ $t('word.contact') }}
        </a>
      </div>
    </div>
  </nav>
</template>

<script>
import { mapGetters } from 'vuex';
import RegisterNewsletter from '@/common/components/registration/RegisterNewsletter.vue';

export default {
  name: 'Footer',
  components: {
    'v-register-newsletter': RegisterNewsletter,
  },
  computed: {
    ...mapGetters(['user']),
    showNewsLetterBar() {
      if (!this.user.isAuthenticated) {
        return false;
      }
      return (this.user.config && !this.user.config.news_letter);
    },
  },
};
</script>


<style scoped>
.text-facebook {
  color: #3B5998;
}

.text-instagram {
  color: #8134AF;
}

.text-linkedin {
  color: #006dac;
}
</style>
